import { actionTypes} from '../actions/rates'
import createAsyncReducer from './HOCreducer'

export default createAsyncReducer(actionTypes)
